import { useState, useCallback } from 'react';

type TFnSetter<T> = (prevVal: T) => T;

export default function useLocalStorageState<T>(
  optName: string,
  defaultValue: T
): [T, (value: T | TFnSetter<T>) => void] {
  const storageJson = localStorage.getItem(optName);
  const [localValue, setLocalValue] = useState<T>(
    storageJson ? (JSON.parse(storageJson) as T) : defaultValue
  );

  const setter = useCallback((value: T | TFnSetter<T>) => {
    if (typeof value === 'function') {
      setLocalValue(prev => {
        const newVal = (value as TFnSetter<T>)(prev);
        localStorage.setItem(optName, JSON.stringify(newVal));
        return newVal;
      });
    } else {
      localStorage.setItem(optName, JSON.stringify(value));
      setLocalValue(value);
    }
  }, []);

  return [localValue, setter];
}
